import React, { useEffect, useRef } from 'react';
import { Button, Modal } from 'semantic-ui-react';
import Swal from 'sweetalert2';
import queryString from 'query-string';
import generacionesService from '../../../../services/api/generacionesService';
import moment from 'moment';

const REDIRECT_SECONDS = 7;

export const PostConfirmModal = ({ message, onContinue, onGoToMainPage }) => {
  const timeoutRef = useRef(null);
  const countdownRef = useRef(REDIRECT_SECONDS);
  const onGoToMainPageRef = useRef(onGoToMainPage);
  const countdownStartedRef = useRef(false);
  const [secondsLeft, setSecondsLeft] = React.useState(null);

  onGoToMainPageRef.current = onGoToMainPage;

  useEffect(() => {
    const startCountdown = () => {
      if (countdownStartedRef.current) return;
      countdownStartedRef.current = true;
      countdownRef.current = REDIRECT_SECONDS;
      setSecondsLeft(REDIRECT_SECONDS);

      const tick = () => {
        countdownRef.current -= 1;
        setSecondsLeft(countdownRef.current);
        if (countdownRef.current <= 0) {
          onGoToMainPageRef.current();
          return;
        }
        timeoutRef.current = setTimeout(tick, 1000);
      };
      timeoutRef.current = setTimeout(tick, 1000);
    };

    const handleVisibilityChange = () => {
      if (document.visibilityState === 'visible') {
        startCountdown();
      }
    };

    if (document.visibilityState === 'visible') {
      startCountdown();
    }
    document.addEventListener('visibilitychange', handleVisibilityChange);
    return () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange);
      if (timeoutRef.current) clearTimeout(timeoutRef.current);
    };
  }, [message]);

  const handleContinue = () => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
      timeoutRef.current = null;
    }
    onContinue();
  };

  const handleGoToMain = () => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
      timeoutRef.current = null;
    }
    onGoToMainPage();
  };

  return (
    <Modal open size="small" closeOnDimmerClick={false}>
      <Modal.Header>Reserva confirmada</Modal.Header>
      <Modal.Content>
        <p>{message}</p>
        <p style={{ fontSize: '0.9em', marginTop: 8 }}>
          {secondsLeft === null
            ? 'Cuando vuelvas a esta página tendrás 5 segundos para hacer clic en Continuar; si no, serás redirigido al inicio.'
            : `Si no haces clic en Continuar en ${secondsLeft} segundos, serás redirigido al inicio.`}
        </p>
      </Modal.Content>
      <Modal.Actions>
        <Button primary onClick={handleContinue}>
          Continuar
        </Button>
        <Button secondary onClick={handleGoToMain}>
          Volver al inicio
        </Button>
      </Modal.Actions>
    </Modal>
  );
};

export const printEntry = (kid, parent, date, category) => {
  const printQueueQuery = {
    category,
    date,
    code: Math.random().toString(36).substring(8),
    identification: kid?.identification,
    name: `${kid?.name} ${kid?.lastName}`,
    parentFullname: `${parent?.name} ${parent?.lastName}`,
    parentIdentification: parent?.identification,
    birthdate: kid?.birthdate,
    phone: parent?.phone,
    observations: kid?.aditionalinformation?.Nota,
  };
  window.open(
    `/checkin/print?${queryString.stringify(printQueueQuery, { sort: false })}`,
    '_blank'
  );
};

export const confirmReservationGeneraciones = (
  eventSlugname,
  getInfo,
  kid,
  parent,
  set_loading,
  onShowPostConfirm
) => {
  set_loading(true);
  generacionesService
    .ConfirmGeneracionesReservation({
      generaciones_guest_id: kid.id,
      eventSlugname,
    })
    .then((response) => {
      if (response.data.success) {
        const category =
          response?.data?.reserved?.['GeneracionesEventsGuests.generacionesCategory'] ||
          'generaciones';
        const date = moment
          .tz(response?.data?.reserved?.date, 'America/Bogota')
          .format('dddd DD [de] MMMM hh:mm a');
        printEntry(kid, parent, date, category);
        if (onShowPostConfirm) {
          onShowPostConfirm(response.data.message);
        } else {
          getInfo();
          Swal.fire(response.data.message);
        }
      }
    })
    .catch((error) => {
      if (error.response) Swal.fire(error.response.data.message);
    });
};

const ConfirmReservationModal = (props) => {
  const [loading, set_loading] = React.useState(false);

  const { eventSlugname, getInfo, kid, parent, onShowPostConfirm } = props;

  return (
    <Button
      primary
      loading={loading}
      onClick={() =>
        confirmReservationGeneraciones(
          eventSlugname,
          getInfo,
          kid,
          parent,
          set_loading,
          onShowPostConfirm
        )
      }
      size="tiny"
    >
      Confirmar e imprimir escarapela
    </Button>
  );
};

export default ConfirmReservationModal;
